module.exports = __webpack_public_path__ + "static/media/adstringentes.61d6b86f.png";